var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('v-system-bar',{attrs:{"dark":"","height":"35","color":"primary lighten-2"}},[_c('v-spacer'),_vm._v("INFORMACIÓN PEDIDOS NEGOCIO\n  "),_c('v-spacer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }